/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import "./src/styles/global.css"

function setupRevealOnScroll() {
  if (typeof window === "undefined") return;

  const elements = Array.from(document.querySelectorAll(".reveal"));
  if (!elements.length) return;

  const reduced = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
  if (reduced) {
    elements.forEach((el) => el.classList.add("is-revealed"));
    return;
  }

  if (!("IntersectionObserver" in window)) {
    elements.forEach((el) => el.classList.add("is-revealed"));
    return;
  }

  const obs = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-revealed");
          obs.unobserve(entry.target);
        }
      }
    },
    { rootMargin: "0px 0px -10% 0px", threshold: 0.15 }
  );

  elements.forEach((el) => obs.observe(el));
}

export const onInitialClientRender = () => setupRevealOnScroll();
export const onRouteUpdate = () => setupRevealOnScroll();
